import { type ReactElement } from 'react';
import { AgencyActivityTypesField } from 'components';
import { DateRangePickerField } from '@ff-it/form';

export function PriceListForm({ create }: { create?: boolean }): ReactElement {
  return (
    <div className="container px-0 ml-0">
      <div className="form-row">
        <DateRangePickerField label="Period" fromName="date_from" toName="date_to" className="col-md-3" required />
        <AgencyActivityTypesField label="Type" name="type" required className="col-md-2" disabled={!create} />
      </div>
    </div>
  );
}
